// extracted by mini-css-extract-plugin
export var active = "_2h-9";
export var backButton = "_2h-8";
export var clone = "_2h-e";
export var collapseBar = "_2h-k";
export var collapseMode = "_2h-m";
export var collapsed = "_2h-o";
export var dimmed = "_2h-i";
export var dragHandle = "_2h-c";
export var dropdownIcon = "_2h-g";
export var expanding = "_2h-n";
export var hidden = "_2h-x";
export var iconContainer = "_2h-q";
export var iconSwapper = "_2h-w";
export var navItem = "_2h-6";
export var navItemIcon = "_2h-f";
export var navProfile = "_2h-7";
export var notificationCountBadge = "_2h-j";
export var notificationDot = "_2h-r";
export var optionsContainer = "_2h-h";
export var primaryNav = "_2h-0";
export var primaryNavDivider = "_2h-v";
export var primaryNavResizeHandle = "_2h-2";
export var primaryNavResizing = "_2h-1";
export var primaryNavTabSection = "_2h-u";
export var primaryTab = "_2h-p";
export var primaryTabIconBox = "_2h-s";
export var secondaryNav = "_2h-3";
export var selected = "_2h-t";
export var settingsNav = "_2h-4";
export var settingsNavItems = "_2h-5";
export var show = "_2h-d";
export var sideNav = "_2h-l";
export var teamItem = "_2h-a";
export var userProfileItem = "_2h-b";